import { useEffect } from "react"; 
import { getToken } from "firebase/messaging";
import useAxios from "../utils/useAxios";
import { messaging } from "../firebase";

const NotificationPermission = () => {
  const axiosInstance = useAxios();

  useEffect(() => {
    const requestPermissionAndToken = async () => {
      try {
        // Demande la permission
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        // Récupère le token FCM
        const token = await getToken(messaging, {
          vapidKey: "BF_BsNt8N1iPpJyYsRkPAaRpd6Cr-J7aWdr1Goi2H7zSaU6gG-aJ3FAtFGoHcMAbjscZ7b68hPVOLr5q0acVCOU",
        });

        if (!token) return;

        // Vérifie si l'utilisateur est connecté avant d'envoyer
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (!authTokens || !authTokens.access) {
          // console.warn("Utilisateur non connecté, token FCM non envoyé.");
          return;
        }

        // Envoie le token au backend
        await axiosInstance.post("/notification/save-fcm-token/", { fcm_token: token });

        // console.log("Token FCM envoyé au backend ✅");
      } catch (error) {
        // console.error("Erreur lors de l’envoi du token :", error);
      }
    };

    requestPermissionAndToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default NotificationPermission;
